module.exports = __webpack_public_path__ + "static/diy-5eeae7bb54442ed986e8eddb6cfbfe52.jpeg";